import { render, staticRenderFns } from "./EditTableBookingPolicyLimit.vue?vue&type=template&id=5228db8d&"
import script from "./EditTableBookingPolicyLimit.vue?vue&type=script&lang=js&"
export * from "./EditTableBookingPolicyLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports